export default {
	"infoTooltip.label": "Hinweis",
} as const;
